export default __webpack_public_path__ + "static/media/hero_text.2226d799.png";